import { parseMarkdown, type Inline } from '@bb/shared';

function Parts({ parts, linkBase }: { parts: Inline[]; linkBase?: string }) {
  return (
    <>
      {parts.map((p, i) =>
        p.t === 'bold' ? <strong key={i}>{p.v}</strong> : p.t === 'italic' ? <em key={i}>{p.v}</em> : p.t === 'link' ? <a key={i} href={linkBase && p.href.startsWith('/') ? linkBase + p.href : p.href} rel="noopener noreferrer">{p.v}</a> : <span key={i}>{p.v}</span>,
      )}
    </>
  );
}

/**
 * Renders policy text as React elements; never as HTML. `linkBase` turns
 * relative links into links to another origin (the beta site links to the main site).
 */
export function Markdown({ source, linkBase }: { source: string; linkBase?: string }) {
  return (
    <div className="md">
      {parseMarkdown(source).map((b, i) => {
        if (b.t === 'h') {
          const H = (`h${Math.min(4, b.level + 1)}`) as 'h2' | 'h3' | 'h4';
          return <H key={i}><Parts parts={b.parts} linkBase={linkBase} /></H>;
        }
        if (b.t === 'ol') return <ol key={i}>{b.items.map((it, j) => <li key={j}><Parts parts={it} linkBase={linkBase} /></li>)}</ol>;
        if (b.t === 'ul') return <ul key={i}>{b.items.map((it, j) => <li key={j}><Parts parts={it} linkBase={linkBase} /></li>)}</ul>;
        if (b.t === 'quote') return <blockquote key={i}><Parts parts={b.parts} linkBase={linkBase} /></blockquote>;
        return <p key={i}><Parts parts={b.parts} linkBase={linkBase} /></p>;
      })}
    </div>
  );
}
